<script setup>
import { ComboboxRoot } from "reka-ui";

defineProps({
  modelValue: { default: undefined },
  defaultValue: { default: undefined },
  multiple: { type: Boolean, default: undefined },
  open: { type: Boolean, default: undefined },
  defaultOpen: { type: Boolean, default: undefined },
  searchTerm: { type: String, default: undefined },
  selectedValue: { default: undefined },
  disabled: { type: Boolean, default: undefined },
  name: { type: String, default: undefined },
  dir: { type: String, default: undefined },
  filterFunction: { type: Function, default: undefined },
  displayValue: { type: Function, default: undefined },
  resetSearchTermOnBlur: { type: Boolean, default: true },
});

defineEmits(["update:modelValue", "update:open", "update:searchTerm"]);
</script>

<template>
  <ComboboxRoot
    v-slot="slotProps"
    data-slot="combobox"
    :model-value="modelValue"
    :default-value="defaultValue"
    :multiple="multiple"
    :open="open"
    :default-open="defaultOpen"
    :search-term="searchTerm"
    :selected-value="selectedValue"
    :disabled="disabled"
    :name="name"
    :dir="dir"
    :filter-function="filterFunction"
    :display-value="displayValue"
    :reset-search-term-on-blur="resetSearchTermOnBlur"
    @update:model-value="$emit('update:modelValue', $event)"
    @update:open="$emit('update:open', $event)"
    @update:search-term="$emit('update:searchTerm', $event)"
  >
    <slot v-bind="slotProps" />
  </ComboboxRoot>
</template>
